function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgQiming(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    id: "qiming_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 96 96",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    "uc-svg": "www"
  }, props), React.createElement("style", null, '.qiming_svg__st0{fill:#0b0c0c}'), React.createElement("path", {
    className: "qiming_svg__st0",
    d: "M48 7.4C25.6 7.4 7.4 25.6 7.4 48S25.6 88.6 48 88.6 88.6 70.4 88.6 48 70.4 7.4 48 7.4zm0 79.8C26.4 87.2 8.8 69.6 8.8 48S26.4 8.8 48 8.8 87.2 26.4 87.2 48 69.6 87.2 48 87.2z"
  }), React.createElement("path", {
    className: "qiming_svg__st0",
    d: "M48.3 16c-17.9 0-32.5 14.6-32.5 32.5v.1h1.1v-.1c0-17.3 14.1-31.4 31.4-31.4 17.3 0 31.4 14.1 31.4 31.4v.1h1.1v-.1C80.8 30.6 66.2 16 48.3 16z"
  }), React.createElement("path", {
    className: "qiming_svg__st0",
    d: "M48.3 26.7c-12 0-21.8 9.8-21.8 21.8v.2h1.1v-.2c0-11.4 9.3-20.7 20.7-20.7S69 37.1 69 48.5v.2h1.1v-.2c0-12-9.8-21.8-21.8-21.8z"
  }), React.createElement("path", {
    className: "qiming_svg__st0",
    d: "M47.8 36.2c-6.8 0-12.3 5.5-12.3 12.3v.1h1.1v-.1c0-6.2 5-11.2 11.2-11.2 6.2 0 11.2 5 11.2 11.2v.1h1.1v-.1c0-6.8-5.5-12.3-12.3-12.3z"
  }));
}

SvgQiming.clsName = 'icon-www__qiming';
SvgQiming.remarkName = 'unknown';
export default SvgQiming;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Qiming.js
// module id = 2407
// module chunks = 17 18